import './LoadingCard.css';

export function LoadingCard() {
  return (
    <div className="loading-card">
      <div className="loading-card-header">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-badge"></div>
      </div>
      <div className="skeleton skeleton-subtitle"></div>
    </div>
  );
}

